export const DISCOUNT_ATTACHMENT_ACCEPT =
  '.pdf,.png,.jpg,.jpeg,.gif,.webp,.doc,.docx,.xls,.xlsx,.csv,.eml,.msg';

export const DISCOUNT_ATTACHMENT_HELP_TEXT =
  'PDF, images, Word, Excel, CSV, email (.eml, .msg)';

export const DISCOUNT_ATTACHMENT_MAX_SIZE_MB = 10;
